import { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import { ReactComponent as CloseIcon } from 'assets/close_icon.svg';
import styles from './customAlert.module.scss';

const DEFAULT_TIMOUT = 3000;

export const CustomAlert: FC = observer(() => {
  const {
    alertStore: { type, message, hideAlert, show },
  } = useStore();

  const [timeOut, setTimeOut] = useState<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    // let t: ReturnType<typeof setTimeout> | undefined;
    if (timeOut !== null) clearTimeout(timeOut);
    if (show) {
      // t = setTimeout(() => {
      //   hide();
      // }, DEFAULT_TIMOUT);
      setTimeOut(
        setTimeout(() => {
          hideAlert();
        }, DEFAULT_TIMOUT)
      );
    } else {
      // eslint-disable-next-line no-lonely-if
      // if (timeOut !== null) clearTimeout(timeOut);
    }
    return () => {
      if (timeOut !== null) clearTimeout(timeOut);
    };
  }, [open]);

  return (
    <div className={`${styles.alertBox} ${styles[type]}`}>
      <p className={styles.alertMsg}>{message}</p>
      <button
        type='button'
        className={styles.btn}
        onClick={() => {
          hideAlert();
        }}>
        <CloseIcon />
      </button>
    </div>
  );
});
